var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.239 38c.96 0 1.738-.883 1.74-1.973 0-.253-.042-.537-.112-.706h-3.256c-.069.17-.111.46-.111.71.002 1.089.78 1.97 1.739 1.969zM34.744 33.052a3.934 3.934 0 0 1-1.225-1.4c-.637-1.252-1.707-3.932-1.707-7.822 0-1.806-.743-3.642-2.039-5.04-1.307-1.41-3.047-2.219-4.773-2.219-1.726 0-3.466.81-4.773 2.22-1.295 1.398-2.039 3.236-2.039 5.041 0 4.138-1.176 6.846-1.877 8.092a3.594 3.594 0 0 1-1.024 1.133.615.615 0 0 0-.077.065.793.793 0 0 0-.21.54c0 .414.328.767.716.767h18.568c.388 0 .716-.353.716-.768 0-.194-.075-.437-.165-.53a.71.71 0 0 0-.091-.08zM26.978 13.786C26.978 12.8 26.2 12 25.24 12c-.96 0-1.739.8-1.739 1.786s.779 1.785 1.739 1.785c.96 0 1.74-.8 1.74-1.785z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ece2dadb.svg";
export { ForwardRef as ReactComponent };